import { Grid, IconButton } from "@mui/material"
import { useState } from "react";
import AutocompleteComponent from "./AutocompleteComponent";
import { getCountriesFromRegions, getRegionsFromCountries } from "../../utils/utilFunctions";
import { Flag, Public } from "@mui/icons-material";

type CountryRegionAutoCompleteProps = {
  availableOptions: any
  filters: any
  setFilters: Function
  countrySelectectionisAnd: boolean
  setCountrySelectionisAnd: Function
}

function CountryRegionAutoComplete({ availableOptions, filters, setFilters, countrySelectectionisAnd, setCountrySelectionisAnd }: CountryRegionAutoCompleteProps) {
  const [isCountrySelection, setIsCountrySelection] = useState(true);


  const handleCountryChange = (event: any, newValue: any) => {
    setFilters((prevFilters: any) => ({ ...prevFilters, countries: newValue }));
  };

  const handleRegionChange = (event: any, newValue: any) => {
    // If regions are selected, convert them to countries
    const countriesFromRegions = getCountriesFromRegions(newValue.map((region: any) => region.key));
    setFilters((prevFilters: any) => ({ ...prevFilters, countries: countriesFromRegions }));
  };

  return (
    <Grid item>
      <Grid container justifyContent="space-evenly" alignItems={"top"}>
        <Grid item xs={12} md={11}>
          {isCountrySelection ? (
            <AutocompleteComponent
              options={availableOptions.countries}
              value={filters.countries}
              handleChange={handleCountryChange}
              isMulti={true}
              label="Countries"
              radioState={countrySelectectionisAnd}
              setRadioState={setCountrySelectionisAnd}
            />
          ) : (
            <AutocompleteComponent
              options={getRegionsFromCountries(availableOptions.countries)}
              value={getRegionsFromCountries(filters.countries)}
              handleChange={handleRegionChange}
              grouped={true}
              isMulti={true}
              label="Regions"
              radioState={countrySelectectionisAnd}
              setRadioState={setCountrySelectionisAnd}
            />
          )}
        </Grid>
        <Grid item xs={12} md={1}>
          <IconButton
            onClick={() => setIsCountrySelection(!isCountrySelection)}
            size="small">
            {isCountrySelection ? (
              <Public />
            ) : (
              <Flag />
            )}
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CountryRegionAutoComplete;